export default __webpack_public_path__ + "img/c78cd65ffd61a1374042aa55101559a1.png";